"use client";
import MobileSelect from "../../baseSelect/mobiles/MultiSelect/index.mobile";
import { formatJobFunctions } from "../../helper";
import { expandSelectedValues, restoreOriginalObjectMobile } from "./helper";

type Valuetype = {
  mainFunctions: string[];
  jobFunctions: string[];
  functionTitles: string[];
};

type PropsType = {
  main_function_filter?: any[];
  value?: Valuetype;
  isMulty?: boolean;
  onChange?: (any) => void;
};

function JobFunctionSelectMobile({
  main_function_filter = [],
  value,
  isMulty = true,
  onChange
}: PropsType) {
  const options = formatJobFunctions(main_function_filter);
  const newValue = expandSelectedValues(value, options);

  const restoreProviderValue = (value) => {
    const changeValue = restoreOriginalObjectMobile(value, options);
    if (onChange) {
      onChange(changeValue);
    }
  };

  return (
    <MobileSelect
      // @ts-ignore
      placeholder='Search Job Function'
      searchTitle='Job Functions'
      value={newValue}
      isMulty={isMulty}
      options={options}
      onChange={restoreProviderValue}
    />
  );
}

export default JobFunctionSelectMobile;
